// extracted by mini-css-extract-plugin
export default {"hoverBtn":"Buttons_hoverBtn__UdGuj","pressBtn":"Buttons_pressBtn__K0W-b"};